export default "__VITE_ASSET__51e99821__"